import { useEffectOnce } from 'react-use';
import { useSelector } from 'react-redux';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

export const useDocumentTitle = (title?: string) => {
  const portalName = useSelector(selectPortalName);

  useEffectOnce(() => {
    document.title = [title, portalName].filter(Boolean).join(' | ');
  });
};
